import {Fragment, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, TablePaging} from "~/components";
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import { Check, X } from "lucide-react";
import AwsChatbotAPI from '~/api/awsChatbotApi';
import classNames from "classnames/bind";
import styles from "~/pages/btai-chatbots/AIChatbot/AIChatbot.module.scss";
const cx = classNames.bind(styles);
const breadCrumbItem = [
    { text: "AI Chatbot Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "User Plan Subscription", to: "", isActive: true },
]

function AwsUserChatManager() {
    const [chatDetails, setChatDetails] = useState([]);
    const [userChatInfo, setUserChatInfo] = useState({});
    const [sessionChatSelected, setSessionChatSelected] = useState({});
    const {getImageUrlById} = useAssetsImage();
    const adminAvatar =getImageUrlById(39);
    const noChatImage =getImageUrlById(50);
    const tablePagingConfig = {
        columns: [
            {
                name: 'USER NAME',
                width: '150px',
                template: function(row){
                    return (
                        <div className="d-flex align-items-center gap-3 fw-semibold text-body-highlight " data-discover="true">
                            <div className="square-icon-box border border-translucent overflow-hidden position-relative">
                                <img className="w-100 h-100 pointer-events-none" alt="" src={row.AvatarUrl } style={{aspectRatio: "16 / 9"}}/>
                            </div>
                            <p className="mb-0">{row.UserName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'LIST SESSION CHAT',
                width: '400px',
                template: (row) => {
                    const sessionTitles = JSON.parse(row.SessionTitles || "[]");
                    return(
                        <ul className="list-unstyled mb-0">
                            {
                                sessionTitles.map((item, index) => (
                                    <li className="d-flex" key={index}>
                                        <a onClick={(e) => {
                                                e.preventDefault();
                                                handleClickSessionChat(row.UserId, item.SessionId);
                                                const {SessionTitles, ...restData} = row;
                                                setUserChatInfo(restData);
                                                setSessionChatSelected(item);
                                            }}
                                           className="text-ellipsis d-block fw-bold"
                                           style={{width: "170px"}}
                                           href="#"
                                        >
                                            {item.Title}
                                        </a>
                                        <span className="fs-10 fw-semibold ms-4" style={{lineHeight: "20px"}}>
                                            {item.IsActive ? <Check size={12} className="me-3 text-success"/> : <X size={12} className="me-3 text-danger"/>}
                                            ({format(new Date(item.CreatedDate), "dd-MM-yyyy hh:mm a")})
                                        </span>
                                    </li>
                                ))
                            }
                        </ul>
                    )
                }
            },
        ],
        url: "/aws-chatbots/paged",
        tableKey: "TableUserPlanSubscription",
        hasShowHideColumn: false
    }

    const handleClickSessionChat = (userId, sessionId) => {
        const params = new URLSearchParams({
            userId: userId,
            sessionId: sessionId,
        });
        AwsChatbotAPI.getChatHistoryBySessionId(params)
            .then(res => {
                setChatDetails(res.data);
            })
    }

    const renderButton = (chatButton) => {
        const buttons = chatButton ? JSON.parse(chatButton) : [];
        return (
            <Fragment>
                {
                    buttons.map((button, index) => (
                        <div key={index} title={button.Text} className={cx("chat-button", "fs-8-1 border")}>
                            <span className={cx('button-text','fs-9 fw-semibold')}>{button.Text}</span>
                        </div>
                    ))
                }
            </Fragment>
        )
    }

    const renderChatDetail = () =>{
        return (
            <Fragment>
                {
                    chatDetails.length > 0 ?
                        (
                            chatDetails.map((chatDetail, index) =>(
                                <div className="timeline-item" key={index}>
                                    <div className="g-3 row">
                                        <div className="col-auto">
                                            <div className="position-relative timeline-separator">
                                                <div className="avatar avatar-l">
                                                    <img alt="avatar" className={`rounded-circle ${chatDetail.ChatTypeId == 1 ? "" : "bg-logo"}`} src={chatDetail.ChatTypeId == 1 ? userChatInfo.AvatarUrl : adminAvatar}/>
                                                </div>
                                                {index !== chatDetails.length - 1 && (
                                                    <span className="h-100 border-dashed timeline-bar border-end"></span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="timeline-content">
                                                <div className="d-flex justify-content-between">
                                                    <div className="d-flex mb-2">
                                                        <h6 className="lh-sm mb-0 me-2 text-body-secondary timeline-item-title">
                                                            {chatDetail.ChatTypeId == 1 ? userChatInfo.UserName : "Break Through"}
                                                        </h6>
                                                    </div>
                                                    <div className="text-body-quaternary fs-9 fw-bold text-nowrap timeline-time">
                                                        {format(new Date(chatDetail.CreatedDate), "dd-MM-yyyy hh:mm a")}
                                                    </div>
                                                </div>
                                                <div className={cx("chat-content-detail", "fs-9 fw-semibold text-body-secondary mb-0 mb-1")}>
                                                    {chatDetail.ChatContent}
                                                </div>
                                                <div className={cx("chat-buttons","d-flex mt-0 mb-5 w-100")}>
                                                    {renderButton(chatDetail.ChatButtons)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center">
                                <span className="fs-8-1 fw-bold"> Selected session to view chat details. </span>
                                <img alt="" className="img-fluid" src={noChatImage}/>
                            </div>
                        )
                }
            </Fragment>
        )
    }

    return(
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-5">AWS User Chat Manager</h2>
            <div className="row">
                <div className="col-xl-5 col-lg-12 mb-7">
                    <TablePaging tablePagingConfig={tablePagingConfig}/>
                </div>
                <div className="col-xl-7 col-lg-12">
                    <div>
                        <div className="text-center mb-3 border-bottom pb-1">
                            <span className="fs-8-1 fw-bold">{sessionChatSelected.Title}</span>
                        </div>
                        <div className="mb-9 timeline-basic">
                            {renderChatDetail()}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AwsUserChatManager;